module.exports = __webpack_public_path__ + "c44d46105f166227492bc58f8c72500b.svg";